import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain, CreditCard, MousePointer, Globe } from 'lucide-react';

const FeatureCards = () => {
  const navigate = useNavigate();

  const features = [
    {
      title: 'Smart Personalization',
      description: 'AI that tailors messaging to each recipient',
      icon: <Brain className="h-6 w-6 text-purple-600" />,
      color: 'bg-purple-100 hover:bg-purple-200',
      path: '/features/smart-personalization',
    },
    {
      title: 'Flexible Pricing',
      description: 'Plans that grow with your business',
      icon: <CreditCard className="h-6 w-6 text-green-600" />,
      color: 'bg-green-100 hover:bg-green-200',
      path: '/features/flexible-pricing',
    },
    {
      title: 'Easy to Use',
      description: 'Intuitive design anyone can master',
      icon: <MousePointer className="h-6 w-6 text-blue-600" />,
      color: 'bg-blue-100 hover:bg-blue-200',
      path: '/features/easy-to-use',
    },
    {
      title: 'Global Reach',
      description: 'Connect with customers worldwide',
      icon: <Globe className="h-6 w-6 text-amber-600" />,
      color: 'bg-amber-100 hover:bg-amber-200',
      path: '/features/global-reach',
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {features.map((feature, index) => (
          <div 
            key={index}
            className={`rounded-xl p-6 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg cursor-pointer ${feature.color}`}
            onClick={() => navigate(feature.path)}
          >
            <div className="flex items-center space-x-4">
              <div className="flex-shrink-0">
                {feature.icon}
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">{feature.title}</h3>
                <p className="text-sm text-gray-600">{feature.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureCards;